import React, { useEffect, useState, useRef } from "react";
import Skeleton from "./skeleton";
import { useSearchParams, NavLink } from "react-router-dom";
import Moment from "react-moment";
import WalletAdjustment from "./adjustment/generate";
import RefundModal from "./adjustment/refund";
import { Services } from "../../../../../Services";
import { warningSwal, SuccessSwal } from "../../../../../Util/Toast";
import transactionClasses from "./transactions.module.css";
import { AiOutlineClose } from "react-icons/ai";
function Transactions() {
    const [params] = useSearchParams();
    const [Loading, setLoading] = useState(true);
    const [refund, setRefund] = useState(false);
    const [Invoice, setInvoice] = useState(null);
    const [modal, setModal] = useState(false);
    const [transaction, setTransactions] = useState({
        transaction: [],
        TotalWalletAmount: 0,
        MobileNumber: "",
    });
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [exportFilter, setExportFilter] = useState({
        FilterType: "all",
        FromDate: "",
        ToDate: "",
    });
    const [exporting, setExporting] = useState(false);
    const [expandedRows, setExpandedRows] = useState({});

    // Handler extracted so form submit (Enter) works
    const handleExportSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        // validate dates
        if (
            exportFilter.FromDate &&
            exportFilter.ToDate &&
            new Date(exportFilter.FromDate) > new Date(exportFilter.ToDate)
        ) {
            warningSwal("Warning", "From Date cannot be after To Date");
            return;
        }
        setExporting(true);
        try {
            const res = await Services.parentwallet_reports(
                "GET",
                null,
                token,
                params.get("Id"),
                exportFilter.FilterType,
                exportFilter.FromDate || null,
                exportFilter.ToDate || null
            );
            if (res?.Status === 1 && res?.CsvFile) {
                // Open in new tab; browser will handle download
                window.open(res.CsvFile, "_blank");
                setExportModalOpen(false);
                SuccessSwal("Success", "Export started");
            } else {
                warningSwal("Warning", (res && res.Message) || "Export failed");
            }
        } catch (err) {
            console.error(err);
            warningSwal("Warning", "Something went wrong while exporting");
        } finally {
            setExporting(false);
        }
    };

    // refs for modal and first input for accessibility
    const modalContentRef = useRef(null);
    const firstControlRef = useRef(null);

    // Close modal on ESC and focus first input when opened
    useEffect(() => {
        const onKey = (ev) => {
            if (ev.key === "Escape") setExportModalOpen(false);
        };
        if (exportModalOpen) {
            document.addEventListener("keydown", onKey);
            // focus first control after a tick
            setTimeout(() => {
                firstControlRef.current && firstControlRef.current.focus();
            }, 60);
        }
        return () => document.removeEventListener("keydown", onKey);
    }, [exportModalOpen]);

    useEffect(() => {
        Transactions();
    }, []);
    async function Transactions() {
        try {
            const Transactions = await Services.parentWallet(
                "GET",
                null,
                token,
                params.get("Id")
            );
            setTimeout(() => {
                setLoading(false);
            }, 500);
            if (Transactions.Status === 1) {
                setTransactions({
                    transaction: Transactions.Wallets,
                    InvoiceBalance: Transactions.InvoiceBalance,
                    MobileNumber: Transactions.MobileNumber,
                    TotalWalletAmount: Transactions?.TotalWalletAmount
                        ? Transactions?.TotalWalletAmount
                        : 0,
                });
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
            alert("Something went wrong try again");
        }
    }
    const refundHandler = (item) => {
        setInvoice(item);
        setRefund(true);
    };
    return (
        <div className={transactionClasses["Container"]}>
            <WalletAdjustment
                showPaymentModal={modal}
                setShowPaymentModal={setModal}
                MobileNumber={transaction.MobileNumber}
                Transactions={Transactions}
                TotalWalletAmount={transaction.TotalWalletAmount}
            />
            {refund && (
                <RefundModal
                    showPaymentModal={refund}
                    invoice={Invoice}
                    setShowPaymentModal={setRefund}
                    MobileNumber={transaction.MobileNumber}
                    Transactions={Transactions}
                    TotalWalletAmount={transaction.TotalWalletAmount}
                />
            )}
            <header>
                <h3>Payments </h3>
                <div>
                    <span className={transactionClasses["balance"]}>
                        Wallet Balance :
                        <bold>
                            {" "}
                            ₹{" "}
                            {Number(transaction?.TotalWalletAmount).toFixed(2)}
                        </bold>
                    </span>
                    <span className={transactionClasses["balance"]}>
                        Invoice Balance :
                        <bold>
                            {" "}
                            ₹ {Number(transaction?.InvoiceBalance).toFixed(2)}
                        </bold>
                    </span>
                    <button onClick={() => setModal(true)}>
                        Wallet Adjustment
                    </button>
                    <button onClick={() => setExportModalOpen(true)}>
                        Export
                    </button>
                </div>
            </header>

            {exportModalOpen && (
                <div
                    className={transactionClasses.overlay}
                    onMouseDown={(e) => {
                        // close when clicking outside modal content
                        if (e.target === e.currentTarget)
                            setExportModalOpen(false);
                    }}>
                    <div
                        className={transactionClasses.modal}
                        role="dialog"
                        aria-modal="true"
                        ref={modalContentRef}>
                        <form
                            className={transactionClasses["form-wrapper"]}
                            onSubmit={handleExportSubmit}>
                            <button
                                onClick={() => setExportModalOpen(false)}
                                aria-label="close">
                                <AiOutlineClose />
                            </button>
                            <h2>Export Wallet Report</h2>
                            <p
                                style={{
                                    margin: 0,
                                    color: "#555",
                                    fontSize: "0.95rem",
                                }}>
                                Choose filters to generate the wallet report.
                                The file will be opened in a new tab when ready.
                            </p>

                            <div className={transactionClasses["form-control"]}>
                                <label>Filter Type</label>
                                <div className={transactionClasses["input"]}>
                                    <select
                                        value={exportFilter.FilterType}
                                        onChange={(e) =>
                                            setExportFilter((p) => ({
                                                ...p,
                                                FilterType: e.target.value,
                                            }))
                                        }>
                                        <option value="all">All</option>
                                        <option value="credited">
                                            Credited
                                        </option>
                                        <option value="debited">Debited</option>
                                    </select>
                                </div>
                            </div>

                            <div className={transactionClasses["form-control"]}>
                                <label>From Date</label>
                                <div className={transactionClasses["input"]}>
                                    <input
                                        type="date"
                                        value={exportFilter.FromDate}
                                        onChange={(e) =>
                                            setExportFilter((p) => ({
                                                ...p,
                                                FromDate: e.target.value,
                                            }))
                                        }
                                        ref={firstControlRef}
                                    />
                                </div>
                            </div>

                            <div className={transactionClasses["form-control"]}>
                                <label>To Date</label>
                                <div className={transactionClasses["input"]}>
                                    <input
                                        type="date"
                                        value={exportFilter.ToDate}
                                        onChange={(e) =>
                                            setExportFilter((p) => ({
                                                ...p,
                                                ToDate: e.target.value,
                                            }))
                                        }
                                    />
                                </div>
                            </div>

                            <div className={transactionClasses.buttons}>
                                <button
                                    type="button"
                                    className={transactionClasses["cancel-btn"]}
                                    onClick={() => setExportModalOpen(false)}>
                                    Cancel
                                </button>
                                <button
                                    className={transactionClasses.submit}
                                    type="submit"
                                    disabled={exporting}>
                                    {exporting && (
                                        <span
                                            className={
                                                transactionClasses.spinner
                                            }
                                            aria-hidden="true"></span>
                                    )}
                                    {exporting ? " Exporting..." : "Export"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {Loading ? (
                <Skeleton />
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>Transaction Date</th>
                            <th>Class Date</th>
                            <th>Type</th>
                            <th>Comments</th>
                            <th>Credit</th>
                            <th>Debit</th>
                            <th>Transaction ID</th>
                            <th>Invoice</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transaction?.transaction?.length > 0 ? (
                            transaction?.transaction?.map((item, idx) => (
                                <tr key={idx}>
                                    <td>
                                        <Moment format="DD-MM-YYYY" utc>
                                            {new Date(item.CreatedAt_IST)}
                                        </Moment>
                                    </td>
                                    <td>
                                        {item.Type == 1 || item?.Type == 4 ? (
                                            <NavLink
                                                to={`/scheduledClasses/Details?scheduleID=${item.ScheduleClassID}`}>
                                                <Moment format="DD-MM-YYYY">
                                                    {item?.Scheduled_StartDate}
                                                </Moment>
                                            </NavLink>
                                        ) : (
                                            "NA"
                                        )}
                                    </td>
                                    <td style={{ maxWidth: "6rem" }}>
                                        {item.Type === 1
                                            ? "Lesson Complete"
                                            : item.Type === 2
                                                ? "Manual balance Adjustment"
                                                : item.Type == 3
                                                    ? "Top up"
                                                    : item.Type === 4
                                                        ? "Class Cancel"
                                                        : item.Type === 5
                                                            ? "Course Registration"
                                                            : item.Type === 6
                                                                ? "Payment from Payment Link(Admin generated)"
                                                                : "Payment from Payment Link(Low Balance Link)"}
                                    </td>
                                    <td style={{ maxWidth: "300px" }}>
                                        <div
                                            className={
                                                transactionClasses[
                                                "commentWrapper"
                                                ]
                                            }>
                                            {(() => {
                                                const text =
                                                    item?.Comments || "";
                                                const isLong =
                                                    text.split("\n").length >
                                                    2 || text.length > 40;
                                                return (
                                                    <>
                                                        <div
                                                            className={`${transactionClasses[
                                                                "comment"
                                                            ]
                                                                } ${expandedRows[
                                                                    idx
                                                                ]
                                                                    ? transactionClasses[
                                                                    "commentExpanded"
                                                                    ]
                                                                    : ""
                                                                }`}>
                                                            {text}
                                                        </div>
                                                        {isLong && (
                                                            <button
                                                                type="button"
                                                                className={
                                                                    transactionClasses[
                                                                    "readMoreBtn"
                                                                    ]
                                                                }
                                                                onClick={() =>
                                                                    setExpandedRows(
                                                                        (
                                                                            p
                                                                        ) => ({
                                                                            ...p,
                                                                            [idx]: !p[
                                                                                idx
                                                                            ],
                                                                        })
                                                                    )
                                                                }>
                                                                {expandedRows[
                                                                    idx
                                                                ]
                                                                    ? "Show less"
                                                                    : "Read more"}
                                                            </button>
                                                        )}
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </td>
                                    <td style={{ maxWidth: "4rem" }}>
                                        {item.IsCredited == 1 ? (
                                            <span
                                                style={{
                                                    color: "darkgreen",
                                                    fontWeight: "600",
                                                }}>
                                                ₹{" "}
                                                {Number(item.Amount).toFixed(2)}
                                            </span>
                                        ) : (
                                            "⎼⎼⎼⎼⎼⎼"
                                        )}
                                    </td>
                                    <td style={{ maxWidth: "4rem" }}>
                                        {" "}
                                        {item.IsCredited == 2 ||
                                            item.IsCredited == 0 ? (
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontWeight: "600",
                                                }}>
                                                ₹{" "}
                                                {Number(item.Amount).toFixed(2)}
                                            </span>
                                        ) : (
                                            "⎼⎼⎼⎼⎼⎼"
                                        )}
                                    </td>
                                    <td>{item?.TransactionID}</td>
                                    <td style={{ maxWidth: "7rem" }}>
                                        <div
                                            className={
                                                transactionClasses[
                                                "refund_btns"
                                                ]
                                            }>
                                            {item?.InvoiceFile != "NA" && (
                                                <a
                                                    href={item?.InvoiceFile}
                                                    target="_blank">
                                                    Link
                                                </a>
                                            )}
                                            {item?.InvoiceFile != "NA" &&
                                                item?.IsCredited == 1 &&
                                                item?.IsRefunded == 0 && (
                                                    <button
                                                        className={
                                                            transactionClasses[
                                                            "refund-btn"
                                                            ]
                                                        }
                                                        onClick={() =>
                                                            refundHandler(item)
                                                        }>
                                                        Refund
                                                    </button>
                                                )}
                                            {item?.IsRefunded == 1 && (
                                                <p
                                                    className={
                                                        transactionClasses[
                                                        "refunded"
                                                        ]
                                                    }>
                                                    Refunded
                                                </p>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={4} style={{ textAlign: "center" }}>
                                    No Record Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default Transactions;
